var map = {
	"./afb-color.svg": 1527,
	"./alb-color.svg": 1528,
	"./all.svg": 1529,
	"./amb-color.svg": 1530,
	"./arg.svg": 1531,
	"./aus.svg": 1532,
	"./bank-icon.svg": 1533,
	"./bankdemo-color.svg": 1534,
	"./bel.svg": 1535,
	"./bimb-color.svg": 1536,
	"./bkr-color.svg": 1537,
	"./bpay-color.svg": 1538,
	"./bra.svg": 1539,
	"./bsn-color.svg": 1540,
	"./can.svg": 1541,
	"./checked-white.png": 1542,
	"./cimb-color.svg": 1543,
	"./cimb-icon.svg": 1544,
	"./citi-color.svg": 1545,
	"./cmr.svg": 1546,
	"./crc.svg": 1547,
	"./cro.svg": 1548,
	"./den.svg": 1549,
	"./ecu.svg": 1550,
	"./eng.svg": 1551,
	"./esp.svg": 1552,
	"./esports-active-m.svg": 1553,
	"./esports-m.svg": 1554,
	"./fav-gray.png": 1555,
	"./fav-icon-active.png": 1556,
	"./fav-icon.png": 1557,
	"./fav-red.png": 1558,
	"./fra.svg": 1559,
	"./game-icon.svg": 1560,
	"./games-active-m.svg": 1561,
	"./games-m.svg": 1562,
	"./ger.svg": 1563,
	"./gha.svg": 1564,
	"./gxbank-color.svg": 1565,
	"./hlb-color.svg": 1566,
	"./hlb-icon.svg": 1567,
	"./hsbc-color.svg": 1568,
	"./irn.svg": 1569,
	"./jpn.svg": 1570,
	"./kor.svg": 1571,
	"./ksa.svg": 1572,
	"./kwh-color.svg": 1573,
	"./latest-icon-active.png": 1574,
	"./latest-icon.png": 1575,
	"./lc-active-m.svg": 1576,
	"./lc-icon.svg": 1577,
	"./lc-m.svg": 1578,
	"./lottery-active-m.svg": 1579,
	"./lottery-icon.svg": 1580,
	"./lottery-m.svg": 1581,
	"./love.svg": 1582,
	"./mar.svg": 1583,
	"./mbb-color.svg": 1584,
	"./mex.svg": 1585,
	"./ned.svg": 1586,
	"./ocbc-color.svg": 1587,
	"./ocbc-icon.svg": 1588,
	"./p2p-active-m.svg": 1589,
	"./p2p-icon.svg": 1590,
	"./p2p-m.svg": 1591,
	"./pbb-color.svg": 1592,
	"./pol.svg": 1593,
	"./por.svg": 1594,
	"./price-high.svg": 1595,
	"./price-low.svg": 1596,
	"./qat.svg": 1597,
	"./rhb-color.svg": 1598,
	"./rhb-icon.svg": 1599,
	"./scb-color.svg": 1600,
	"./sen.svg": 1601,
	"./slot-active-m.svg": 1602,
	"./slot-icon.svg": 1603,
	"./slot-m.svg": 1604,
	"./sport-active-m.svg": 1605,
	"./sport-m.svg": 1606,
	"./sports-icon.svg": 1607,
	"./square-icon.svg": 1608,
	"./srb.svg": 1609,
	"./star.svg": 1610,
	"./sui.svg": 1611,
	"./tng-color.svg": 1612,
	"./trx-icon.svg": 1613,
	"./trx.svg": 1614,
	"./tun.svg": 1615,
	"./uefa-icon.svg": 1616,
	"./uob-color.svg": 1617,
	"./uru.svg": 1618,
	"./usa.svg": 1619,
	"./usdc.svg": 1620,
	"./usdt.svg": 1621,
	"./ustd-icon.svg": 1622,
	"./wal.svg": 1623,
	"./x33-logo-b.svg": 1624,
	"./x33-square-icon.svg": 1625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;